// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"523":"24f478c9","955":"c9fed544"}[chunkId] + ".css";
};